<section class="main-section">
    <header class="d-flex justify-content-between align-items-center main-heading">
        <div class="d-flex align-items-center">
          <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
            role="button" aria-controls="offcanvasExample">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            </svg></a>
          <h3 class="heading-span">
            <span>Request Access</span>
          </h3>        
        </div>
      </header>
    <div class="bg-white d-flex justify-content-between align-items-center radius8 mb-3 py-2">
        <div [formGroup]="packageForm" class="content-box w-100">
          <div class="col-sm-6">
            <div class="edit-account-selectoption hide-label">
              <span class="black-text fs-14 mb-1">Audience Type</span>
              <mat-form-field>
                <mat-select required formControlName="role"
                  (selectionChange)="onSelectingRole($event.value)"
                  [class.is-invalid]="packageForm.controls['role'].invalid && packageForm.controls['role'].touched">
                  @for (role of roles; track role) {
                    <mat-option [value]="role.roleId">{{role.roleName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="(packageForm.controls['role'].invalid && packageForm.controls['role'].touched) || packageForm.controls['role'].dirty">
              <small *ngIf="packageForm.controls['role'].errors?.['required']" class="text-danger fs-13">Role is required</small>
            </div>
          </div>
            <div class="my-2">
                <div class="d-flex">
                  <span class="black-text fs-14 mb-1">Module</span>
                  <mat-icon matTooltip="Modules already assigned to this role cannot be edited. Only new modules can be requested to add" class="ms-2 fs-22">info</mat-icon>
                </div>
                <mat-form-field>
                  <mat-select #moduleSelect required formControlName="modules" 
                  
                  multiple (selectionChange)="onModuleChange($event)"
                  [class.is-invalid]="packageForm.controls['modules'].invalid && packageForm.controls['modules'].touched">
                    <mat-select-trigger>
                      <span class="chip-list-head">Added Items:</span>
                      <span class="chip-main">
                        <span *ngFor="let moduleValue of packageForm.controls['modules'].value" class="chip-list">{{moduleValue.moduleName}}
                          <a class="close" *ngIf="!isAlreadySelected(moduleValue, true)" (click)="$event.stopPropagation(); $event.preventDefault(); removeModule(moduleValue)">
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </span>
                      </span>
                      @if ((packageForm.controls['modules'].value?.length || 0) > 0) {
                      <span class="chip-list count" (click)="$event.stopPropagation(); $event.preventDefault(); previewPopup('Added Modules','Module')">
                        #{{(packageForm.controls['modules'].value?.length)}}
                      </span>
                      }
                    </mat-select-trigger>
                    @for (module of modules; track module) {
                      <mat-option [value]="module" [disabled]="isReadOnly || isAlreadySelected(module, true)">{{module.moduleName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="my-2">
                <div class="d-flex">
                  <span class="black-text fs-14 mb-1">Sub Category</span>
                  <mat-icon matTooltip="Analytics Toolkits already assigned to this role cannot be edited. Only new Analytics Toolkits can be requested to add" class="ms-2 fs-22">info</mat-icon>
                </div>
                <mat-form-field>
                  <mat-select #subcategorySelect required formControlName="subCategories" multiple
                  (valueChange)="this.groupedSubCategories = this._createGroupedValues($event);"
                  (selectionChange)="onSubCategoryChange($event)"
                  [class.is-invalid]="packageForm.controls['subCategories'].invalid && packageForm.controls['subCategories'].touched">
                    <mat-select-trigger>
                      <span class="chip-list-head">Added Items:</span>
                      <span class="chip-main">
                        <span *ngFor="let moduleGroup of groupedSubCategories | keyvalue" >
                              <h4 class="black-text fs-14 mb-1" style="font-weight: bolder; margin-top: 1em;">{{moduleGroup.key}}</h4>

                              <span *ngFor="let subCategoryValue of moduleGroup.value" 
                              style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;"
                              class="chip-list toolkit-display" title="{{subCategoryValue.subCategoryName}}">
                                <label class="toolkit-display"  >
                                  <mat-icon style="font-size: 1.8em;" *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                                  <span class="toolkit-display-text" *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                                  <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                                </label>
                                <a class="close"
                                  *ngIf="!isAlreadySelected(subCategoryValue, false)" 
                                  (click)="$event.stopPropagation(); $event.preventDefault(); removeSubCategory(subCategoryValue)">
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                              </span>
                            </span>
                      </span>
                      @if ((packageForm.controls['subCategories'].value?.length || 0) > 0) {
                      <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault(); previewPopup('Added Analytics Toolkits', 'SubCategory')">
                        #{{(packageForm.controls['subCategories'].value?.length)}}
                      </span>
                      }
                    </mat-select-trigger>
                    
                    <mat-optgroup *ngFor="let rg of (this.availableGroupedSubCategories??{}) | keyvalue" [label]="rg.key">
                       @for (subCategory of rg.value; track subCategory) {
                      <mat-option 
                        [disabled]="isReadOnly || isAlreadySelected(subCategory, false)"
                        [class.multiline]="subCategory.subCategoryDisplayName!=null" 
                        [value]="subCategory">
                          @if(subCategory.subCategoryDisplayName==null)
                          {
                            {{subCategory.subCategoryName}}
                          }
                          @else {
                            <label class="toolkit-display">
                              <mat-icon >short_text</mat-icon>
                              <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                              <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                            </label>
                          }
                        </mat-option>
                    }
                  </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              </div>
        </div>
   </div>
   <div class="sticky-btns">
    <div class="row">
      <div class="col-sm-12 text-right">
        @if(isReadOnly){
          <button type="button" class="btn theme-btn-outline px-5" (click)="sharedService.loadReportCheck(true)">Close</button> 
        }
        @else{
          <button type="button" class="btn theme-btn-outline px-5" (click)="sharedService.loadReportCheck(true)">Cancel</button>           
          <button type="button" class="btn theme-btn px-5 ms-3" (click)="requestAccess()" >Request Access</button>
        }
        
      </div>
    </div>
  </div>
</section>